export default __webpack_public_path__ + "static/media/Graph.c56140da.gif";